// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images//info.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/images//show-toyota.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/images//show-lexus.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/images//hide-toyota.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/images//hide-lexus.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../assets/images//edit.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../assets/images//Artboard 4.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../assets/images//delete.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../assets/images//active-flag.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../assets/images//inactive-flag.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../../assets/images//Artboard 3down.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../../assets/images//Artboard 3up.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../../assets/images//rocket.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../../assets/images//calendar.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.activityContainer {
    font-size: 0.81rem;
    font-family: "Arial", sans-serif;
    max-width: none !important;
    margin-bottom: 3rem;
}

.activityTableContainer .tab-content {
    border-bottom-right-radius: 1.25rem;
    border-bottom-left-radius: 1.25rem;
    border-top-right-radius: 1.25rem;
    background-color: #f0f0f0;
    padding: 1.25rem;
    /* height: 33rem;
    width: 81.5rem; */
}

.activityTableContainer .activity-content {
    border-bottom-right-radius: 1.25rem;
    border-bottom-left-radius: 1.25rem;
    border-top-right-radius: 1.25rem;
    border-top-left-radius: 1.25rem;
    background-color: #f0f0f0;
    /* width: 81.5rem; */
}

.info-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    height: 19px;
    width: 19px;
    background-position: center;
    margin: 0 0.3rem;
}

.toyota-show-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    height: 19px;
    width: 19px;
    background-position: center;
    margin: 0 0.3rem;
}

.lexus-show-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    height: 19px;
    width: 19px;
    background-position: center;
    margin: 0 0.3rem;
}

.toyota-hide-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    height: 19px;
    width: 19px;
    background-position: center;
    margin: 0 0.3rem;
}

.lexus-hide-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    height: 19px;
    width: 19px;
    background-position: center;
    margin: 0 0.3rem;
}

.edit-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
    height: 19px;
    width: 18px;
    background-position: center;
    margin: 0 0.3rem;
}

.add-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
    height: 25px;
    width: 26px;
    background-position: center;
    margin: 0 0.3rem;
    float: right;
    margin-left: 0.75rem !important;
    margin-top: -0.31rem !important;
}

.view-icon {
    /* background-image: url("../../assets/images//view.png"); */
    height: 19px;
    width: 30px;
    background-position: center;
    background-repeat: no-repeat;
    margin: 0 0.3rem;
    float: right;
}

.launch-icon {
    /* background-image: url("../../assets/images//launch.png"); */
    height: 19px;
    width: 30px;
    background-position: center;
    background-repeat: no-repeat;
    margin: 0 0.3rem;
    float: right;
}

.delete-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
    height: 19px;
    width: 18px;
    background-position: center;
    margin: 0 0.3rem;
}

.noPadding {
    padding: 0px !important;
    margin: 0px !important;
}

.lexus-FontWithBold {
    color: #252525;
    font-weight: bold;
    padding-left: 1rem !important;
    padding-top: 1.0rem;
    margin-top: 0.2rem;
}

.toyota-FontWithBold {
    color: #e50000;
    font-weight: bold;
    padding-left: 1rem !important;
    padding-top: 1.0rem;
    margin-top: 0.2rem;
}

.searchActivityTable {
    padding: 1rem;
    min-height: 300px !important;
}

/* Table header stick  */

/* .searchActivityTable thead, .searchActivityTable tbody, .searchActivityTable tr, .searchActivityTable td, .searchActivityTable th { display: block; }
.searchActivityTable .react-bootstrap-table{
    height: 25rem !important;
}
.searchActivityTable tr:after {
    content: ' ';
    display: block;
    visibility: hidden;
    clear: both;
}

.searchActivityTable tbody {
    height: 21.8rem;
    overflow-y: auto;
}

.searchActivityTable tbody > tr > td { 
    width: 7.5rem; 
    float: left;
} 
.searchActivityTable thead > tr > th { 
    width: 7.5rem;
    float: left;
}  */

/* .searchActivityTable thead > tr > th:first-child { 
    width: 5rem !important;
    float: left;
}
.searchActivityTable tbody > tr > td:first-child  { 
    width: 5rem;
    float: left;
} */

/* Table stick header end  */

/* .searchActivityTable .react-bootstrap-table{
    padding:1rem;
}

.searchActivityTable tbody tr {
    border: 1px solid grey !important;
    border-radius: 5px;
} */

.searchActivityTable .active-flag {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
    height: 18px;
    width: 18px;
    background-position: center;
    margin: 0 0.3rem;
    margin-left: 2.03rem;
}

.searchActivityTable .inactive-flag {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
    height: 18px;
    width: 18px;
    background-position: center;
    margin: 0 0.3rem;
    margin-left: 2.03rem;
}

.boldFont {
    font-weight: bold;
    padding-top: 1.0rem;
}

.activity-content input {
    border-radius: 0.25rem !important;
}

tbody tr {
    border-bottom: 5px solid #f0f0f0!important;
}

.deleteConfirmBox {
    padding: 1rem;
    background-color: #FFFFFF;
    border-radius: 20px;
    width: 30rem;
    font-family: "Arial", sans-serif;
    font-size: 0.81rem;
}

.deleteConfirmBox .modal-footer {
    padding: 0px;
}

.parent-toyota #pageDropDown {
    background-color: #E50000 !important;
}

.parent-lexus #pageDropDown {
    background-color: #252525 !important;
}

.pagination {
    float: right;
}

.parent-toyota .pagination .active>a {
    background-color: #E50000 !important;
}

.parent-lexus .pagination .active>a {
    background-color: #252525 !important;
}

.react-bootstrap-table-pagination-list {
    padding-top: 0px;
}

span.order span.dropdown {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
    width: 16px;
    height: 20px;
    float: left;
    background-position: center;
    position: absolute;
    background-size: 80px 60px;
    visibility: hidden;
}

span.order span.dropup {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
    width: 16px;
    height: 20px;
    float: left;
    position: absolute;
    background-position: center;
    background-size: 80px 60px;
    visibility: hidden;
}

.activityTable tbody, .activityTable tr {
    display: block;
}

.activityTable tr:after {
    content: ' ';
    display: block;
    visibility: hidden;
    clear: both;
}

.activityTable tbody {
    height: 74vh;
    overflow-y: scroll;
}

.activityTable table {
    border-spacing: 3px 7px;
    border-collapse: separate;
    margin-bottom: 0px !important;
}

.activityTable tbody>tr>td {
    width: 7rem;
    float: left;
    text-overflow: ellipsis;
    overflow: hidden;
}

.activityTable thead>tr>th {
    width: 7rem;
    float: left;
}

.rocket {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}

.hideSortIcon {
    visibility: hidden 
}

.showSortIcon {
    visibility: visible !important
}

div.activityTable div.row.react-bootstrap-table-pagination div {
    padding: 0px !important;
}

.scoreLabel {
    z-index: 10;
    position: absolute;
    top: 0;
    left: 0;
    margin-left: 41%;
    color:white;
}
.scoreProgressBar .progress {
    top: 0;	
    left: 0;
}

.searchActivity {
    padding: 1rem;
    border-left: 6px solid;
    border-left-color: #e50000;
    border-right: 6px solid;
    border-right-color: #e50000;
    border-top: 1px solid;
    border-top-color: #000000;
    border-bottom: 1px solid;
    border-bottom-color: #000000;
}

.hrClass {
    padding: 0px !important;
}

.searchActivity .noPadding {
    padding: 0px;
}

.searchActivity .css-10nd86i svg {
    color: #e50000;
}

.searchActivity .css-1492t68 {
    text-indent: -9999px;
}

.searchActivity .css-va7pk8 {
    color: #595d60 !important;
}

.searchActivity .react-datepicker__input-container {
    width: 11.7rem;
}

.bigDD-toyota .react-datepicker__close-icon::after {
    background-color: #e50000;
}

.bigDD-lexus .react-datepicker__close-icon::after {
    background-color: #252525;
}

.searchActivity #startDate, .searchActivity #completeDate, .searchActivity #startDateTo, .searchActivity #completeDateTo {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
    background-repeat: no-repeat;
    background-position: right;
    cursor: pointer;
}

.Select-menu-outer {
    max-height: 1000px;
}

.Select-menu {
    max-height: 998px;
}

.bigDD-toyota .css-1r4vtzz, .bigDD-toyota .css-48ayfv, .bigDD-lexus .css-1r4vtzz, .bigDD-lexus .css-48ayfv {
    width: 11.7rem;
}

.bigDD-toyota .css-1r4vtzz svg, .bigDD-toyota .css-48ayfv svg {
    color: #e50000 !important;
}

.bigDD-lexus .css-1r4vtzz svg, .bigDD-lexus .css-48ayfv svg {
    color: #252525 !important;
}

.smallDD-toyota .css-1r4vtzz svg, .smallDD-toyota .css-48ayfv svg {
    color: #e50000 !important;
}

.smallDD-lexus .css-1r4vtzz svg, .smallDD-lexus .css-48ayfv svg {
    color: #252525 !important;
}

.smallDD-toyota .css-1r4vtzz, .smallDD-toyota .css-48ayfv, .smallDD-toyota .react-datepicker__input-container, .smallDD-lexus .css-1r4vtzz, .smallDD-lexus .css-48ayfv, .smallDD-lexus .react-datepicker__input-container {
    width: 9rem;
}

.searchActivity .react-autosuggest__container {
    position: relative;
}

.searchActivity .react-autosuggest__input {
    padding: 10px 10px;
    border: 1px solid #aaa;
    border-color: rgb(219, 212, 212);
    border-radius: 0.25rem !important;
    height: calc(2.25rem + 2px);
    width: 11.7rem;

}



.searchActivity .react-autosuggest__input--open {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    border-radius: 0.25rem !important;
    height: calc(2.25rem + 2px);
    width: 11.7rem;
    
}

.searchActivity .react-autosuggest__suggestions-container--open {
    display: block;
    min-width: 11.7rem;
    border: 1px solid #aaa;
    border-radius: 0.25rem !important;
}

.searchActivity .react-autosuggest__suggestions-list {
    margin: 0;
    padding: 0;
    max-height: 250px;
    overflow-y: auto;
    list-style-type: none;
}

.searchActivity .react-autosuggest__suggestion {
    cursor: pointer;
    padding: 10px 20px;
    background-color: white;
}

.searchActivity .react-autosuggest__suggestion--highlighted {
    background-color: #ddd;
}

#react-autowhatever-1 {
    position: absolute;
    z-index: 9999;
    background: white;
}

.css-15brt4p {
    display: none !important;
}

.css-11unzgr {
    border: 0.5px solid #aaa !important;
}
.searchActivity .form-control{
    height: calc(2.25rem + 2px) !important;
}


.dsabledSelect{
    width: 6.4rem !important;
}



/* CSS for user manage modal */


.addEditUserModal .react-datepicker__input-container {
    width: 12.2rem;
  }
  
  .addEditUserModal .statusDD {
    width: 12.2rem;
  }
  
  .addEditUserModal {
    width: 450px !important;
  }
  
  .addEditUserModal-toyota .react-datepicker__close-icon::after {
    background-color: #e50000;
  }
  
  .addEditUserModal-lexus .react-datepicker__close-icon::after {
    background-color: #252525;
  }
  
  .addEditUserModal #firstVisit, .addEditUserModal #completionOn, .addEditUserModal #reminderOn {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
    background-repeat: no-repeat;
    background-position: right;
    cursor: pointer;
  }
  
  .addEditUserModal-toyota .css-10nd86i svg {
    color: #e50000;
  }
  
  .addEditUserModal-lexus .css-10nd86i svg {
    color: #252525;
  }
  
  .addEditUserModal .css-1492t68 {
    text-indent: -9999px;
  }
  
  .addEditUserModal .css-va7pk8 {
    color: #595d60 !important;
  }
  
  .addEditUserModal .react-autosuggest__container {
    position: relative;
  }
  
  .addEditUserModal .react-autosuggest__input {
    width: 100%;
    padding: 10px 10px;
    border: 1px solid #aaa;
    border-color: rgb(219, 212, 212);
    border-radius: 0.25rem !important;
  }
  
 
  
  .addEditUserModal .react-autosuggest__input--open {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    width: 100%;
    border-radius: 0.25rem !important;
  }
  

  
  .addEditUserModal .react-autosuggest__suggestions-container--open {
    display: block;
    width: 100%;
    border: 1px solid #aaa;
    border-radius: 0.25rem !important;
  }
  
  .addEditUserModal .react-autosuggest__suggestions-list {
    margin: 0;
    padding: 0;
    list-style-type: none;
  }
  
  .addEditUserModal .react-autosuggest__suggestion {
    cursor: pointer;
    padding: 10px 20px;
  }
  
  .addEditUserModal .react-autosuggest__suggestion--highlighted {
    background-color: #ddd;
  }
  
  /*
    ==================================
    Don't change. React calender CSS. 
    */
  
  .react-datepicker {
    font-size: 11px;
  }
  
  .react-datepicker__header {
    padding-top: 0.8em;
  }
  
  .react-datepicker__month {
    margin: 0.4em 1em;
  }
  
  .react-datepicker__day-name, .react-datepicker__day {
    width: 1.9em;
    line-height: 1.9em;
    margin: 0.166em;
  }
  
  .react-datepicker__current-month {
    font-size: 1em;
  }
  
  .react-datepicker__navigation {
    top: 1em;
    line-height: 1.7em;
    border: 0.45em solid transparent;
  }
  
  .react-datepicker__navigation--previous {
    border-right-color: #ccc;
    left: 1em;
  }
  
  .react-datepicker__navigation--next {
    border-left-color: #ccc;
    right: 1em;
  }
  
  .disableAutoSuggest {
    background-color: hsl(0, 0%, 95%);
    border-color: hsl(0, 0%, 90%);
    color: hsl(0, 0%, 60%);
  }
  
  /*
      =================================
    */
  
  .addEditUserModal-toyota .modal-header {
    background-color: #e50000;
    border-top-left-radius: 20px !important;
    border-top-right-radius: 20px !important;
    padding: 0.5rem !important;
  }
  
  .addEditUserModal-lexus .modal-header {
    background-color: #252525;
    border-top-left-radius: 20px !important;
    border-top-right-radius: 20px !important;
    padding: 0.5rem !important;
  }
  
  .addEditUserModal-toyota .modal-dialog, .addEditUserModal-toyota .modal-content {
    border-radius: 24px !important;
    border: 1px solid #e50000 !important;
  }
  
  .addEditUserModal-lexus .modal-dialog, .addEditUserModal-lexus .modal-content {
    border-radius: 24px !important;
    border: 1px solid #252525 !important;
  }

  .roleviewCss{

    background-color: #e9ecef;
  }


.userStatus .css-11unzgr{
    overflow: visible  !important;
}

.userStatus .css-1jllj6i-control{
    min-width: 138px !important;
}

.userStatus .css-6y1x9t-control{
    min-width: 138px !important;
}


.userStatus .css-1pcexqc-container{
    max-width: 152px  !important;
}

.userStatus .css-1qprcsu-option{
    min-width: 138px !important;
}

.userStatus .css-1vr111p-option{
    min-width: 138px !important;
}


.searchActivity .britEmail .react-autosuggest__input {
    padding: 10px 10px;
    border: 1px solid #aaa;
    border-color: rgb(219, 212, 212);
    border-radius: 0.25rem !important;
    height: calc(2.25rem + 2px);
    width: 14rem;

}

.searchActivity .britEmail .react-autosuggest__input--open {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    border-radius: 0.25rem !important;
    height: calc(2.25rem + 2px);
    width: 14rem;
    
}

.searchActivity .britEmail .react-autosuggest__suggestions-container--open {
    display: block;
    min-width: 14rem;
    border: 1px solid #aaa;
    border-radius: 0.25rem !important;
}



`, "",{"version":3,"sources":["webpack://./src/components/userManagement/index.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,mCAAmC;IACnC,kCAAkC;IAClC,gCAAgC;IAChC,yBAAyB;IACzB,gBAAgB;IAChB;qBACiB;AACrB;;AAEA;IACI,mCAAmC;IACnC,kCAAkC;IAClC,gCAAgC;IAChC,+BAA+B;IAC/B,yBAAyB;IACzB,oBAAoB;AACxB;;AAEA;IACI,yDAAsD;IACtD,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,yDAA6D;IAC7D,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,yDAA4D;IAC5D,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,yDAA6D;IAC7D,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,yDAA4D;IAC5D,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,yDAAsD;IACtD,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,yDAA4D;IAC5D,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;IAChB,YAAY;IACZ,+BAA+B;IAC/B,+BAA+B;AACnC;;AAEA;IACI,4DAA4D;IAC5D,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,4BAA4B;IAC5B,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,8DAA8D;IAC9D,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,4BAA4B;IAC5B,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,yDAAwD;IACxD,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,6BAA6B;IAC7B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,6BAA6B;IAC7B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,4BAA4B;AAChC;;AAEA,wBAAwB;;AAExB;;;;;;;;;;;;;;;;;;;;;;;IAuBI;;AAEJ;;;;;;;GAOG;;AAEH,4BAA4B;;AAE5B;;;;;;;GAOG;;AAEH;IACI,yDAA6D;IAC7D,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,yDAA+D;IAC/D,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,0DAAgE;IAChE,WAAW;IACX,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,kBAAkB;IAClB,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,0DAA8D;IAC9D,WAAW;IACX,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,2BAA2B;IAC3B,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,WAAW;IACX,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,0DAAwD;AAC5D;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,MAAM;IACN,OAAO;AACX;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,0BAA0B;IAC1B,uBAAuB;IACvB,2BAA2B;IAC3B,qBAAqB;IACrB,yBAAyB;IACzB,wBAAwB;IACxB,4BAA4B;AAChC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,0DAA0D;IAC1D,4BAA4B;IAC5B,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,gCAAgC;IAChC,iCAAiC;IACjC,2BAA2B;IAC3B,cAAc;;AAElB;;;;AAIA;IACI,4BAA4B;IAC5B,6BAA6B;IAC7B,iCAAiC;IACjC,2BAA2B;IAC3B,cAAc;;AAElB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,sBAAsB;IACtB,iCAAiC;AACrC;;AAEA;IACI,SAAS;IACT,UAAU;IACV,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;AACA;IACI,sCAAsC;AAC1C;;;AAGA;IACI,wBAAwB;AAC5B;;;;AAIA,8BAA8B;;;AAG9B;IACI,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,0DAA0D;IAC1D,4BAA4B;IAC5B,0BAA0B;IAC1B,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,gCAAgC;IAChC,iCAAiC;EACnC;;;;EAIA;IACE,4BAA4B;IAC5B,6BAA6B;IAC7B,WAAW;IACX,iCAAiC;EACnC;;;;EAIA;IACE,cAAc;IACd,WAAW;IACX,sBAAsB;IACtB,iCAAiC;EACnC;;EAEA;IACE,SAAS;IACT,UAAU;IACV,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;;KAGG;;EAEH;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,QAAQ;IACR,kBAAkB;IAClB,gCAAgC;EAClC;;EAEA;IACE,wBAAwB;IACxB,SAAS;EACX;;EAEA;IACE,uBAAuB;IACvB,UAAU;EACZ;;EAEA;IACE,iCAAiC;IACjC,6BAA6B;IAC7B,sBAAsB;EACxB;;EAEA;;KAEG;;EAEH;IACE,yBAAyB;IACzB,uCAAuC;IACvC,wCAAwC;IACxC,0BAA0B;EAC5B;;EAEA;IACE,yBAAyB;IACzB,uCAAuC;IACvC,wCAAwC;IACxC,0BAA0B;EAC5B;;EAEA;IACE,8BAA8B;IAC9B,oCAAoC;EACtC;;EAEA;IACE,8BAA8B;IAC9B,oCAAoC;EACtC;;EAEA;;IAEE,yBAAyB;EAC3B;;;AAGF;IACI,6BAA6B;AACjC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;;AAGA;IACI,4BAA4B;AAChC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;;AAGA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,gCAAgC;IAChC,iCAAiC;IACjC,2BAA2B;IAC3B,YAAY;;AAEhB;;AAEA;IACI,4BAA4B;IAC5B,6BAA6B;IAC7B,iCAAiC;IACjC,2BAA2B;IAC3B,YAAY;;AAEhB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,sBAAsB;IACtB,iCAAiC;AACrC","sourcesContent":[".activityContainer {\n    font-size: 0.81rem;\n    font-family: \"Arial\", sans-serif;\n    max-width: none !important;\n    margin-bottom: 3rem;\n}\n\n.activityTableContainer .tab-content {\n    border-bottom-right-radius: 1.25rem;\n    border-bottom-left-radius: 1.25rem;\n    border-top-right-radius: 1.25rem;\n    background-color: #f0f0f0;\n    padding: 1.25rem;\n    /* height: 33rem;\n    width: 81.5rem; */\n}\n\n.activityTableContainer .activity-content {\n    border-bottom-right-radius: 1.25rem;\n    border-bottom-left-radius: 1.25rem;\n    border-top-right-radius: 1.25rem;\n    border-top-left-radius: 1.25rem;\n    background-color: #f0f0f0;\n    /* width: 81.5rem; */\n}\n\n.info-icon {\n    background-image: url(\"../../assets/images//info.png\");\n    height: 19px;\n    width: 19px;\n    background-position: center;\n    margin: 0 0.3rem;\n}\n\n.toyota-show-icon {\n    background-image: url(\"../../assets/images//show-toyota.png\");\n    height: 19px;\n    width: 19px;\n    background-position: center;\n    margin: 0 0.3rem;\n}\n\n.lexus-show-icon {\n    background-image: url(\"../../assets/images//show-lexus.png\");\n    height: 19px;\n    width: 19px;\n    background-position: center;\n    margin: 0 0.3rem;\n}\n\n.toyota-hide-icon {\n    background-image: url(\"../../assets/images//hide-toyota.png\");\n    height: 19px;\n    width: 19px;\n    background-position: center;\n    margin: 0 0.3rem;\n}\n\n.lexus-hide-icon {\n    background-image: url(\"../../assets/images//hide-lexus.png\");\n    height: 19px;\n    width: 19px;\n    background-position: center;\n    margin: 0 0.3rem;\n}\n\n.edit-icon {\n    background-image: url(\"../../assets/images//edit.png\");\n    height: 19px;\n    width: 18px;\n    background-position: center;\n    margin: 0 0.3rem;\n}\n\n.add-icon {\n    background-image: url(\"../../assets/images//Artboard 4.png\");\n    height: 25px;\n    width: 26px;\n    background-position: center;\n    margin: 0 0.3rem;\n    float: right;\n    margin-left: 0.75rem !important;\n    margin-top: -0.31rem !important;\n}\n\n.view-icon {\n    /* background-image: url(\"../../assets/images//view.png\"); */\n    height: 19px;\n    width: 30px;\n    background-position: center;\n    background-repeat: no-repeat;\n    margin: 0 0.3rem;\n    float: right;\n}\n\n.launch-icon {\n    /* background-image: url(\"../../assets/images//launch.png\"); */\n    height: 19px;\n    width: 30px;\n    background-position: center;\n    background-repeat: no-repeat;\n    margin: 0 0.3rem;\n    float: right;\n}\n\n.delete-icon {\n    background-image: url(\"../../assets/images//delete.png\");\n    height: 19px;\n    width: 18px;\n    background-position: center;\n    margin: 0 0.3rem;\n}\n\n.noPadding {\n    padding: 0px !important;\n    margin: 0px !important;\n}\n\n.lexus-FontWithBold {\n    color: #252525;\n    font-weight: bold;\n    padding-left: 1rem !important;\n    padding-top: 1.0rem;\n    margin-top: 0.2rem;\n}\n\n.toyota-FontWithBold {\n    color: #e50000;\n    font-weight: bold;\n    padding-left: 1rem !important;\n    padding-top: 1.0rem;\n    margin-top: 0.2rem;\n}\n\n.searchActivityTable {\n    padding: 1rem;\n    min-height: 300px !important;\n}\n\n/* Table header stick  */\n\n/* .searchActivityTable thead, .searchActivityTable tbody, .searchActivityTable tr, .searchActivityTable td, .searchActivityTable th { display: block; }\n.searchActivityTable .react-bootstrap-table{\n    height: 25rem !important;\n}\n.searchActivityTable tr:after {\n    content: ' ';\n    display: block;\n    visibility: hidden;\n    clear: both;\n}\n\n.searchActivityTable tbody {\n    height: 21.8rem;\n    overflow-y: auto;\n}\n\n.searchActivityTable tbody > tr > td { \n    width: 7.5rem; \n    float: left;\n} \n.searchActivityTable thead > tr > th { \n    width: 7.5rem;\n    float: left;\n}  */\n\n/* .searchActivityTable thead > tr > th:first-child { \n    width: 5rem !important;\n    float: left;\n}\n.searchActivityTable tbody > tr > td:first-child  { \n    width: 5rem;\n    float: left;\n} */\n\n/* Table stick header end  */\n\n/* .searchActivityTable .react-bootstrap-table{\n    padding:1rem;\n}\n\n.searchActivityTable tbody tr {\n    border: 1px solid grey !important;\n    border-radius: 5px;\n} */\n\n.searchActivityTable .active-flag {\n    background-image: url(\"../../assets/images//active-flag.png\");\n    height: 18px;\n    width: 18px;\n    background-position: center;\n    margin: 0 0.3rem;\n    margin-left: 2.03rem;\n}\n\n.searchActivityTable .inactive-flag {\n    background-image: url(\"../../assets/images//inactive-flag.png\");\n    height: 18px;\n    width: 18px;\n    background-position: center;\n    margin: 0 0.3rem;\n    margin-left: 2.03rem;\n}\n\n.boldFont {\n    font-weight: bold;\n    padding-top: 1.0rem;\n}\n\n.activity-content input {\n    border-radius: 0.25rem !important;\n}\n\ntbody tr {\n    border-bottom: 5px solid #f0f0f0!important;\n}\n\n.deleteConfirmBox {\n    padding: 1rem;\n    background-color: #FFFFFF;\n    border-radius: 20px;\n    width: 30rem;\n    font-family: \"Arial\", sans-serif;\n    font-size: 0.81rem;\n}\n\n.deleteConfirmBox .modal-footer {\n    padding: 0px;\n}\n\n.parent-toyota #pageDropDown {\n    background-color: #E50000 !important;\n}\n\n.parent-lexus #pageDropDown {\n    background-color: #252525 !important;\n}\n\n.pagination {\n    float: right;\n}\n\n.parent-toyota .pagination .active>a {\n    background-color: #E50000 !important;\n}\n\n.parent-lexus .pagination .active>a {\n    background-color: #252525 !important;\n}\n\n.react-bootstrap-table-pagination-list {\n    padding-top: 0px;\n}\n\nspan.order span.dropdown {\n    background-image: url(\"../../assets/images//Artboard 3down.png\");\n    width: 16px;\n    height: 20px;\n    float: left;\n    background-position: center;\n    position: absolute;\n    background-size: 80px 60px;\n    visibility: hidden;\n}\n\nspan.order span.dropup {\n    background-image: url(\"../../assets/images//Artboard 3up.png\");\n    width: 16px;\n    height: 20px;\n    float: left;\n    position: absolute;\n    background-position: center;\n    background-size: 80px 60px;\n    visibility: hidden;\n}\n\n.activityTable tbody, .activityTable tr {\n    display: block;\n}\n\n.activityTable tr:after {\n    content: ' ';\n    display: block;\n    visibility: hidden;\n    clear: both;\n}\n\n.activityTable tbody {\n    height: 74vh;\n    overflow-y: scroll;\n}\n\n.activityTable table {\n    border-spacing: 3px 7px;\n    border-collapse: separate;\n    margin-bottom: 0px !important;\n}\n\n.activityTable tbody>tr>td {\n    width: 7rem;\n    float: left;\n    text-overflow: ellipsis;\n    overflow: hidden;\n}\n\n.activityTable thead>tr>th {\n    width: 7rem;\n    float: left;\n}\n\n.rocket {\n    background-image: url(\"../../assets/images//rocket.png\");\n}\n\n.hideSortIcon {\n    visibility: hidden \n}\n\n.showSortIcon {\n    visibility: visible !important\n}\n\ndiv.activityTable div.row.react-bootstrap-table-pagination div {\n    padding: 0px !important;\n}\n\n.scoreLabel {\n    z-index: 10;\n    position: absolute;\n    top: 0;\n    left: 0;\n    margin-left: 41%;\n    color:white;\n}\n.scoreProgressBar .progress {\n    top: 0;\t\n    left: 0;\n}\n\n.searchActivity {\n    padding: 1rem;\n    border-left: 6px solid;\n    border-left-color: #e50000;\n    border-right: 6px solid;\n    border-right-color: #e50000;\n    border-top: 1px solid;\n    border-top-color: #000000;\n    border-bottom: 1px solid;\n    border-bottom-color: #000000;\n}\n\n.hrClass {\n    padding: 0px !important;\n}\n\n.searchActivity .noPadding {\n    padding: 0px;\n}\n\n.searchActivity .css-10nd86i svg {\n    color: #e50000;\n}\n\n.searchActivity .css-1492t68 {\n    text-indent: -9999px;\n}\n\n.searchActivity .css-va7pk8 {\n    color: #595d60 !important;\n}\n\n.searchActivity .react-datepicker__input-container {\n    width: 11.7rem;\n}\n\n.bigDD-toyota .react-datepicker__close-icon::after {\n    background-color: #e50000;\n}\n\n.bigDD-lexus .react-datepicker__close-icon::after {\n    background-color: #252525;\n}\n\n.searchActivity #startDate, .searchActivity #completeDate, .searchActivity #startDateTo, .searchActivity #completeDateTo {\n    background-image: url(\"../../assets/images//calendar.png\");\n    background-repeat: no-repeat;\n    background-position: right;\n    cursor: pointer;\n}\n\n.Select-menu-outer {\n    max-height: 1000px;\n}\n\n.Select-menu {\n    max-height: 998px;\n}\n\n.bigDD-toyota .css-1r4vtzz, .bigDD-toyota .css-48ayfv, .bigDD-lexus .css-1r4vtzz, .bigDD-lexus .css-48ayfv {\n    width: 11.7rem;\n}\n\n.bigDD-toyota .css-1r4vtzz svg, .bigDD-toyota .css-48ayfv svg {\n    color: #e50000 !important;\n}\n\n.bigDD-lexus .css-1r4vtzz svg, .bigDD-lexus .css-48ayfv svg {\n    color: #252525 !important;\n}\n\n.smallDD-toyota .css-1r4vtzz svg, .smallDD-toyota .css-48ayfv svg {\n    color: #e50000 !important;\n}\n\n.smallDD-lexus .css-1r4vtzz svg, .smallDD-lexus .css-48ayfv svg {\n    color: #252525 !important;\n}\n\n.smallDD-toyota .css-1r4vtzz, .smallDD-toyota .css-48ayfv, .smallDD-toyota .react-datepicker__input-container, .smallDD-lexus .css-1r4vtzz, .smallDD-lexus .css-48ayfv, .smallDD-lexus .react-datepicker__input-container {\n    width: 9rem;\n}\n\n.searchActivity .react-autosuggest__container {\n    position: relative;\n}\n\n.searchActivity .react-autosuggest__input {\n    padding: 10px 10px;\n    border: 1px solid #aaa;\n    border-color: rgb(219, 212, 212);\n    border-radius: 0.25rem !important;\n    height: calc(2.25rem + 2px);\n    width: 11.7rem;\n\n}\n\n\n\n.searchActivity .react-autosuggest__input--open {\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n    border-radius: 0.25rem !important;\n    height: calc(2.25rem + 2px);\n    width: 11.7rem;\n    \n}\n\n.searchActivity .react-autosuggest__suggestions-container--open {\n    display: block;\n    min-width: 11.7rem;\n    border: 1px solid #aaa;\n    border-radius: 0.25rem !important;\n}\n\n.searchActivity .react-autosuggest__suggestions-list {\n    margin: 0;\n    padding: 0;\n    max-height: 250px;\n    overflow-y: auto;\n    list-style-type: none;\n}\n\n.searchActivity .react-autosuggest__suggestion {\n    cursor: pointer;\n    padding: 10px 20px;\n    background-color: white;\n}\n\n.searchActivity .react-autosuggest__suggestion--highlighted {\n    background-color: #ddd;\n}\n\n#react-autowhatever-1 {\n    position: absolute;\n    z-index: 9999;\n    background: white;\n}\n\n.css-15brt4p {\n    display: none !important;\n}\n\n.css-11unzgr {\n    border: 0.5px solid #aaa !important;\n}\n.searchActivity .form-control{\n    height: calc(2.25rem + 2px) !important;\n}\n\n\n.dsabledSelect{\n    width: 6.4rem !important;\n}\n\n\n\n/* CSS for user manage modal */\n\n\n.addEditUserModal .react-datepicker__input-container {\n    width: 12.2rem;\n  }\n  \n  .addEditUserModal .statusDD {\n    width: 12.2rem;\n  }\n  \n  .addEditUserModal {\n    width: 450px !important;\n  }\n  \n  .addEditUserModal-toyota .react-datepicker__close-icon::after {\n    background-color: #e50000;\n  }\n  \n  .addEditUserModal-lexus .react-datepicker__close-icon::after {\n    background-color: #252525;\n  }\n  \n  .addEditUserModal #firstVisit, .addEditUserModal #completionOn, .addEditUserModal #reminderOn {\n    background-image: url(\"../../assets/images//calendar.png\");\n    background-repeat: no-repeat;\n    background-position: right;\n    cursor: pointer;\n  }\n  \n  .addEditUserModal-toyota .css-10nd86i svg {\n    color: #e50000;\n  }\n  \n  .addEditUserModal-lexus .css-10nd86i svg {\n    color: #252525;\n  }\n  \n  .addEditUserModal .css-1492t68 {\n    text-indent: -9999px;\n  }\n  \n  .addEditUserModal .css-va7pk8 {\n    color: #595d60 !important;\n  }\n  \n  .addEditUserModal .react-autosuggest__container {\n    position: relative;\n  }\n  \n  .addEditUserModal .react-autosuggest__input {\n    width: 100%;\n    padding: 10px 10px;\n    border: 1px solid #aaa;\n    border-color: rgb(219, 212, 212);\n    border-radius: 0.25rem !important;\n  }\n  \n \n  \n  .addEditUserModal .react-autosuggest__input--open {\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n    width: 100%;\n    border-radius: 0.25rem !important;\n  }\n  \n\n  \n  .addEditUserModal .react-autosuggest__suggestions-container--open {\n    display: block;\n    width: 100%;\n    border: 1px solid #aaa;\n    border-radius: 0.25rem !important;\n  }\n  \n  .addEditUserModal .react-autosuggest__suggestions-list {\n    margin: 0;\n    padding: 0;\n    list-style-type: none;\n  }\n  \n  .addEditUserModal .react-autosuggest__suggestion {\n    cursor: pointer;\n    padding: 10px 20px;\n  }\n  \n  .addEditUserModal .react-autosuggest__suggestion--highlighted {\n    background-color: #ddd;\n  }\n  \n  /*\n    ==================================\n    Don't change. React calender CSS. \n    */\n  \n  .react-datepicker {\n    font-size: 11px;\n  }\n  \n  .react-datepicker__header {\n    padding-top: 0.8em;\n  }\n  \n  .react-datepicker__month {\n    margin: 0.4em 1em;\n  }\n  \n  .react-datepicker__day-name, .react-datepicker__day {\n    width: 1.9em;\n    line-height: 1.9em;\n    margin: 0.166em;\n  }\n  \n  .react-datepicker__current-month {\n    font-size: 1em;\n  }\n  \n  .react-datepicker__navigation {\n    top: 1em;\n    line-height: 1.7em;\n    border: 0.45em solid transparent;\n  }\n  \n  .react-datepicker__navigation--previous {\n    border-right-color: #ccc;\n    left: 1em;\n  }\n  \n  .react-datepicker__navigation--next {\n    border-left-color: #ccc;\n    right: 1em;\n  }\n  \n  .disableAutoSuggest {\n    background-color: hsl(0, 0%, 95%);\n    border-color: hsl(0, 0%, 90%);\n    color: hsl(0, 0%, 60%);\n  }\n  \n  /*\n      =================================\n    */\n  \n  .addEditUserModal-toyota .modal-header {\n    background-color: #e50000;\n    border-top-left-radius: 20px !important;\n    border-top-right-radius: 20px !important;\n    padding: 0.5rem !important;\n  }\n  \n  .addEditUserModal-lexus .modal-header {\n    background-color: #252525;\n    border-top-left-radius: 20px !important;\n    border-top-right-radius: 20px !important;\n    padding: 0.5rem !important;\n  }\n  \n  .addEditUserModal-toyota .modal-dialog, .addEditUserModal-toyota .modal-content {\n    border-radius: 24px !important;\n    border: 1px solid #e50000 !important;\n  }\n  \n  .addEditUserModal-lexus .modal-dialog, .addEditUserModal-lexus .modal-content {\n    border-radius: 24px !important;\n    border: 1px solid #252525 !important;\n  }\n\n  .roleviewCss{\n\n    background-color: #e9ecef;\n  }\n\n\n.userStatus .css-11unzgr{\n    overflow: visible  !important;\n}\n\n.userStatus .css-1jllj6i-control{\n    min-width: 138px !important;\n}\n\n.userStatus .css-6y1x9t-control{\n    min-width: 138px !important;\n}\n\n\n.userStatus .css-1pcexqc-container{\n    max-width: 152px  !important;\n}\n\n.userStatus .css-1qprcsu-option{\n    min-width: 138px !important;\n}\n\n.userStatus .css-1vr111p-option{\n    min-width: 138px !important;\n}\n\n\n.searchActivity .britEmail .react-autosuggest__input {\n    padding: 10px 10px;\n    border: 1px solid #aaa;\n    border-color: rgb(219, 212, 212);\n    border-radius: 0.25rem !important;\n    height: calc(2.25rem + 2px);\n    width: 14rem;\n\n}\n\n.searchActivity .britEmail .react-autosuggest__input--open {\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n    border-radius: 0.25rem !important;\n    height: calc(2.25rem + 2px);\n    width: 14rem;\n    \n}\n\n.searchActivity .britEmail .react-autosuggest__suggestions-container--open {\n    display: block;\n    min-width: 14rem;\n    border: 1px solid #aaa;\n    border-radius: 0.25rem !important;\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
